import type en from "../en/admin";
import type { Translation } from "../../types";

const admin: Translation<typeof en> = {
  title: "Back-office",
  intro:
    "Approuvez les entreprises, gérez leurs espaces de travail et les personnes qui en font partie.",
  tabs: {
    invite: "Invitations",
    requests: "Demandes d’accès",
    tenants: "Espaces de travail",
    people: "Personnes",
  },
  suspended: "Suspendu",
  suspend: "Suspendre",
  restore: "Rétablir",
  revoke: "Révoquer",
  when: {
    never: "jamais",
    today: "aujourd’hui",
    yesterday: "hier",
    daysAgo_one: "il y a {{count}} j",
    daysAgo_other: "il y a {{count}} j",
  },
  tenants: {
    loadError: "Impossible de charger les espaces de travail",
    empty:
      "Aucun espace de travail pour l’instant. Approuver une demande d’accès crée le premier.",
    renameAria: "Renommer {{name}}",
    people_one: "<num>{{count}}</num> personne",
    people_other: "<num>{{count}}</num> personnes",
    recordings_one: "<num>{{count}}</num> enregistrement",
    recordings_other: "<num>{{count}}</num> enregistrements",
    stored: "<num>{{size}}</num> stockés",
    lastRecorded: "dernier enregistrement : {{when}}",
    suspendQuestion:
      "Suspendre <strong>{{name}}</strong> ? Tous ses membres — propriétaire compris — perdent l’accès immédiatement. Les enregistrements sont conservés, et un rétablissement rend tout.",
    reasonPlaceholder: "Motif (visible par personne, gardé pour votre référence)",
    suspendWorkspace: "Suspendre l’espace de travail",
  },
  people: {
    searchPlaceholder: "Rechercher par nom ou e-mail…",
    loadError: "Impossible de charger les personnes",
    empty: "Aucun résultat.",
    operator: "Opérateur",
    noWorkspace: "Dans aucun espace de travail",
    makeOperatorTitle: "Donner à cette personne l’accès au back-office",
    makeOperator: "Nommer opérateur",
    removeOperatorTitle: "Retirer l’accès au back-office",
    removeOperator: "Retirer l’opérateur",
    makeOperatorQuestion:
      "Faire de <strong>{{email}}</strong> un opérateur de la plateforme ? Cette personne pourra voir et gérer tous les espaces de travail de la plateforme, ainsi que toutes les personnes qui en font partie.",
    suspendQuestion:
      "Suspendre <strong>{{email}}</strong> ? Cette personne est déconnectée immédiatement et ne pourra plus se connecter, dans aucun espace de travail.",
    suspendAccount: "Suspendre le compte",
  },
  invitations: {
    title: "Inviter quelqu’un",
    body: "La personne reçoit un lien pour définir un mot de passe et nommer son propre espace de travail, dont elle devient propriétaire — libre ensuite d’inviter ses collègues.",
    email: "E-mail",
    emailPlaceholder: "fondateur@entreprise.com",
    name: "Son nom <muted>(facultatif)</muted>",
    namePlaceholder: "Camille Martin",
    note: "Note <muted>(facultatif, affichée dans l’e-mail)</muted>",
    notePlaceholder: "Ravi d’avoir échangé aujourd’hui — voici votre accès.",
    send: "Envoyer l’invitation",
    failed: "Impossible d’envoyer l’invitation.",
    resent: "Invitation renvoyée à {{email}}",
    sent: "{{email}} a été invité",
    joined: "Inscrit",
    joinedOrg: "Inscrit · {{organization}}",
    revoked: "Révoquée",
    expired: "Expirée",
    waiting: "En attente",
  },
  access: {
    title: "Demandes d’accès",
    intro:
      "Approuver crée l’espace de travail et invite le demandeur en tant que propriétaire.",
    status: {
      pending: "nouvelles",
      approved: "approuvées",
      rejected: "refusées",
    },
    loadError: "Impossible de charger les demandes d’accès",
    emptyTitle: {
      pending: "Aucune demande en attente",
      approved: "Aucune demande approuvée",
      rejected: "Aucune demande refusée",
    },
    emptyDescription: {
      pending: "Les nouvelles demandes envoyées depuis le site vitrine apparaissent ici.",
      approved: "Rien n’a encore été approuvé.",
      rejected: "Rien n’a encore été refusé.",
    },
    approve: "Approuver",
    reject: "Refuser",
    newWorkspace: "Nouvel espace de travail",
    name: "Nom",
    address: "Adresse",
    addressInvalid: "Lettres, chiffres et tirets uniquement — et pas un nom réservé.",
    addressHelp: "L’adresse propre à leur espace de travail. Définitive une fois créée.",
    approveFailed: "Impossible d’approuver cette demande.",
    createAndInvite: "Créer et inviter",
  },
};

export default admin;
